import React, { useState } from "react";
import { FileText } from "lucide-react";

/**
 * A hover-triggered popover that shows the item description.
 * Opens automatically when the pointer enters the tab, closes when it leaves.
 * Also acts as a clickable button (toggles the popover on click / for touch).
 */
export default function DescriptionTab({ description, testid }) {
  const [open, setOpen] = useState(false);
  const empty = !description || !description.trim();

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        data-testid={testid}
        onClick={() => setOpen((v) => !v)}
        className="chip inline-flex items-center gap-1.5"
        data-active={open}
        aria-expanded={open}
      >
        <FileText size={12} />
        Item description
      </button>
      {open && (
        <div
          data-testid={testid ? `${testid}-popover` : undefined}
          className="absolute z-50 left-0 top-full mt-2 w-72 bg-white hairline shadow-md p-4"
          role="tooltip"
        >
          <div className="label-eyebrow mb-2">Description</div>
          <p className="text-sm text-neutral-700 leading-relaxed whitespace-pre-wrap max-h-52 overflow-y-auto">
            {empty ? (
              <span className="italic text-neutral-400">No description provided.</span>
            ) : description}
          </p>
        </div>
      )}
    </div>
  );
}
